export default {
  nav: {
    platform: '\ud50c\ub7ab\ud3fc',
    aiAgents: 'AI \uc5d0\uc774\uc804\ud2b8',
    features: '\uae30\ub2a5',
    developers: '\uac1c\ubc1c\uc790',
    roadmap: '\ub85c\ub4dc\ub9f5',
    launchApp: '\uc571 \uc2e4\ud589',
    lightMode: '\ub77c\uc774\ud2b8 \ubaa8\ub4dc',
    darkMode: '\ub2e4\ud06c \ubaa8\ub4dc',
  },
  hero: {
    badge: '\uba54\uc778\ub137 \ub77c\uc774\ube0c',
    title1: 'AI \ub124\uc774\ud2f0\ube0c',
    title2: '\uac70\ub798 \uc778\ud504\ub77c',
    subtitle:
      '\uc628\uccb8\uc778 \ud37c\ud398\uce04\uc5bc, AI \uc2e4\ud589 \uc5d0\uc774\uc804\ud2b8, \uc608\uce21 \uc2dc\uc7a5, \ubc0f \uc2e4\uc2dc\uac04 \uc720\ub3d9\uc131\u2014\ubaa8\ub450 \ud558\ub098\uc758 \ud1b5\ud569\ub41c \ud50c\ub7ab\ud3fc\uc5d0\uc11c.',
    startTrading: '\uac70\ub798 \uc2dc\uc791',
    launchAgent: '\uc5d0\uc774\uc804\ud2b8 \uc2e4\ud589',
    apiDocs: 'API \ubb38\uc11c',
    volume24h: '24H \uac70\ub798\ub7c9',
    activeTraders: '\ud65c\uc131 \ud2b8\ub808\uc774\ub354',
    uptime: '\uac00\ub3d9 \uc2dc\uac04',
    terminalName: 'zhisu-terminal',
    live: '\ub77c\uc774\ube0c',
    oi: '\ubbf8\uacb0\uc81c \uc57d\uc815',
    funding: '\uc790\uae08\ube44\uc728',
    spread: '\uc2a4\ud504\ub808\ub4dc',
    aiActive: 'AI \uc6b4\uc601 \uc911',
    liveTrades: '\uc2e4\uc2dc\uac04 \uac70\ub798',
    realtime: '\uc2e4\uc2dc\uac04',
    long: '\ub871',
    short: '\uc21f',
  },
  metrics: {
    realtimeMetrics: '\uc2e4\uc2dc\uac04 \uc9c0\ud45c',
    platformGlance: '\ud50c\ub7ab\ud3fc \uac1c\uc694',
    volume24h: '24H \uac70\ub798\ub7c9',
    openInterest: '\ubbf8\uacb0\uc81c \uc57d\uc815',
    activeTraders: '\ud65c\uc131 \ud2b8\ub808\uc774\ub354',
    aiExecutions: 'AI \uc2e4\ud589 \ud69f\uc218',
    fundingRate: '\uc790\uae08\ube44\uc728',
    totalTrades: '\ucd1d \uac70\ub798 \ud69f\uc218',
  },
  agents: {
    autonomousIntelligence: '\uc790\uc728 \uc9c0\ub2a5',
    aiTradingAgents: 'AI \uac70\ub798 \uc5d0\uc774\uc804\ud2b8',
    description:
      '\uba38\uc2e0\ub7ec\ub2dd \uc804\ub7b5\uc73c\ub85c 24/7 \uac70\ub798\ud558\ub294 \uc790\uc728 AI \uc5d0\uc774\uc804\ud2b8\ub97c \ubc30\ud3ec\ud558\uc138\uc694. \uac01 \uc5d0\uc774\uc804\ud2b8\ub294 \uc644\uc804\ud788 \ud22c\uba85\ud558\uace0, \uac10\uc0ac\uac00\ub2a5\ud558\uba70, \uc2e4\uc804\uc5d0\uc11c \uac80\uc99d\ub418\uc5c8\uc2b5\ub2c8\ub2e4.',
    pnl30d: 'PNL (30\uc77c)',
    winRate: '\uc2b9\ub960',
    trades24h: '\uac70\ub798 (24h)',
    avgHold: '\ud3c9\uade0 \ubcf4\uc720',
    risk: '\uc704\ud5d8',
    exploreAll: '\ubaa8\ub4e0 \uc5d0\uc774\uc804\ud2b8 \ud0d0\uc0c9',
  },
  features: {
    productSuite: '\uc81c\ud488 \uc2a4\uc704\ud2b8',
    everythingNeed: '\uac70\ub798\uc5d0 \ud544\uc694\ud55c \ubaa8\ub4e0 \uac83',
    description:
      '\ud37c\ud398\uce04\uc5bc\uc5d0\uc11c AI \uc2e4\ud589\uae4c\uc9c0 \uc644\ubcbd\ud55c \uac70\ub798 \uc778\ud504\ub77c. \ubaa8\ub450 \uc628\uccb8\uc778\uc774\uba70 \uc644\uc804\ud788 \ud22c\uba85\ud569\ub2c8\ub2e4.',
    learnMore: '\ub354 \uc54c\uc544\ubcf4\uae30',
  },
  dev: {
    developerFirst: '\uac1c\ubc1c\uc790 \uc6b0\uc120',
    builtForBuilders: '\ube4c\ub354\ub97c \uc704\ud574 \uad6c\ucd95',
    description:
      '\uc644\ubcbd\ud55c API \uc561\uc138\uc2a4, SDK, \ubc0f \uc2e4\uc2dc\uac04 WebSocket \ud53c\ub4dc. \uba87 \ubd84 \uc548\uc5d0 \uac70\ub798 \ubd07, \uc5d0\uc774\uc804\ud2b8, \ubc0f \ucee4\uc2a4\ud140 \uc804\ub7b5\uc744 \uad6c\ucd95\ud558\uc138\uc694.',
    sdksAndApis: 'SDK \ubc0f API',
    restApi: 'REST API',
    websocket: 'WebSocket',
    pythonSdk: 'Python SDK',
    agentSdk: 'Agent SDK',
    tradingSdk: '\uac70\ub798 SDK',
    viewDocs: '\uc804\uccb4 \ubb38\uc11c \ubcf4\uae30',
  },
  arch: {
    systemDesign: '\uc2dc\uc2a4\ud15c \uc124\uacc4',
    dualEngine: '\ub4c0\uc5bc \uc5d4\uc9c4 \uac74\ucd95',
    description:
      '4\uac1c\uc758 \uc804\ubb38 \uc5d4\uc9c4\uc774 \uc870\ud654\ub97c \uc774\ub8e8\uba70 100ms \ubbf8\ub9cc\uc758 \uc2e4\ud589\uacfc \uae30\uad00\uae09 \uc2e0\ub8b0\uc131\uc744 \uc81c\uacf5\ud569\ub2c8\ub2e4.',
    aiEngine: 'AI \uc5d4\uc9c4',
    liquidityEngine: '\uc720\ub3d9\uc131 \uc5d4\uc9c4',
    executionEngine: '\uc2e4\ud589 \uc5d4\uc9c4',
    riskEngine: '\uc704\ud5d8 \uc5d4\uc9c4',
    latency: '\uc9c0\uc5f0',
    models: '\ubaa8\ub378',
    depth: '\uae4a\uc774',
    pairs: '\ud398\uc5b4',
    tps: 'TPS',
    uptime: '\uac00\ub3d9\uc2dc\uac04',
    coverage: '\ucee4\ubc84\ub9ac\uc9c0',
    alerts: '\uacbd\ubcf4',
  },
  roadmap: {
    ourJourney: '\uc6b0\ub9ac\uc758 \uc5ec\uc815',
    roadmap2026: '2026 \ub85c\ub4dc\ub9f5',
    description:
      'AI \ub124\uc774\ud2f0\ube0c \uac70\ub798 \uc778\ud504\ub77c\uc758 \ubbf8\ub798\ub97c \ud55c \ubc88\uc5d0 \ud55c \ub2e8\uacc4\uc529 \uad6c\ucd95\ud558\uace0 \uc788\uc2b5\ub2c8\ub2e4.',
    completed: '\uc644\ub8cc',
    inProgress: '\uc9c4\ud589 \uc911',
    upcoming: '\uc608\uc815',
  },
  footer: {
    product: '\uc81c\ud488',
    developers: '\uac1c\ubc1c\uc790',
    company: '\ud68c\uc0ac',
    legal: '\ubc95\ub960',
    description:
      '\uc628\uccb8\uc778 \ud37c\ud398\uce04\uc5bc, \uc608\uce21 \uc2dc\uc7a5, \ubc0f \uc790\uc728 \uc2e4\ud589\uc744 \uc704\ud55c AI \ub124\uc774\ud2f0\ube0c \uac70\ub798 \uc778\ud504\ub77c.',
    allRights: '\ubaa8\ub4e0 \uad8c\ub9ac \ubcf4\uc720.',
    systemsOperational: '\ubaa8\ub4e0 \uc2dc\uc2a4\ud15c \uc815\uc0c1 \uc791\ub3d9',
  },
  content: {
    agents: {
      scalper: {
        name: 'AI \uc2a4\ucf08\ud37c',
        description:
          '\ubcc0\ub3d9\uc131 \uae09\ub4f1\uc2dc \ucd08\ub2e8\uc704 \uc2e4\ud589\uc73c\ub85c \uace0\ube48\ub3c4 \ub3d9\ub7c9 \uac70\ub798',
      },
      'funding-arb': {
        name: '\uc790\uae08\ube44\uc728 \uc8fc\uc815 \ubd07',
        description:
          '\ud37c\ud398\uce04\uc5bc \uac70\ub798\uc18c\ub97c \ud3ec\ud568\ud55c \uc790\uae08\ube44\uc728 \uc8fc\uc815 \uc790\ub3d9\ud654',
      },
      'meme-hunter': {
        name: '\ubc00 \ud5cc\ud130',
        description:
          '\uc18c\uc15c \uc13c\ud2f0\uba3c\ud2b8 \ubd84\uc11d\uacfc \ubc00\uc5b4\uc788\ub294 \ud1a0\ud070 \uc774\ub3d9 \uc2dc\uc758 \uc870\uae30 \uc9c4\uc785',
      },
      'prediction-ai': {
        name: '\uc608\uce21 AI',
        description:
          '71% \uc815\ud655\ub3c4\ub85c \uc2dc\uc7a5 \ubc29\ud5a5\uc744 \uc608\uce21\ud558\ub294 \uba38\uc2e0\ub7ec\ub2dd \ubaa8\ub378',
      },
      'whale-tracker': {
        name: '\ud6c4\uc5f4 \ud2b8\ub798\ucee4',
        description:
          '\uc628\uccb8\uc778 \ubd84\uc11d\uc73c\ub85c \uc2a4\ub9c8\ud2b8 \uba38\ub2c8 \uc774\ub3d9\uacfc \ud6c4\uc5f4 \uc9c0\uac11 \ucd94\uc801',
      },
    },
    features: {
      perpetual: {
        title: '\ud37c\ud398\uce04\uc5bc \uac70\ub798',
        description:
          '\ucd5c\ub300 50\ubc30 \ub808\ubc84\ub9ac\uc9c0, \uc800\uc2a4\ud504\ub9ac\uc9c0 \uc5c6\ub294 \uc644\ubcbd\ud55c \uc628\uccb8\uc778 \ud37c\ud398\uce04\uc5bc \ud6c4\uc18d',
      },
      'ai-execution': {
        title: 'AI \uc2e4\ud589',
        description:
          'AI \uae30\ubc18 \uc8fc\ubb38 \ub77c\uc6b0\ud305\uacfc \ubaa8\ub4e0 \uc2dc\uc7a5\uc758 \ucd5c\uc801 \uc9c4\uc785 \ud0c0\uc774\ubc0d',
      },
      prediction: {
        title: '\uc608\uce21 \uc2dc\uc7a5',
        description:
          '\uc554\ud638\ud654\ud3d0 \uacb0\uacfc\uc5d0 \ub300\ud55c \uc989\uc2dc \uacb0\uc81c\uac00 \uac00\ub2a5\ud55c \ubd84\uc0b0\ud615 \uc608\uce21 \uc2dc\uc7a5',
      },
      'copy-trading': {
        title: '\ubcf5\uc0ac \uac70\ub798',
        description:
          '\uc6b0\uc218 \uc131\uacfc\ub97c \ub0b4\ub294 AI \uc5d0\uc774\uc804\ud2b8\uc640 \uac80\uc99d\ub41c \ud2b8\ub808\uc774\ub354\ub97c \ud55c \ubc88\uc758 \ud074\ub9ad\uc73c\ub85c \ub530\ub77c\uac00\uae30',
      },
      hyperevm: {
        title: 'HyperEVM',
        description:
          'Ethereum, Solana, Arbitrum, Base\ub97c \ud3ec\ud568\ud55c \ud06c\ub85c\uc2a4\uccb4\uc778 \ud655\uc7a5',
      },
      vault: {
        title: '\uc804\ub7b5 \ubcfc\ud2b8',
        description:
          '\ub0b4\uc7a5 \uc704\ud5d8\uad00\ub9ac\ub97c \uac16\ucda4 \uc790\ub3d9 \uc218\uc775 \uc0dd\uc131 \uc804\ub7b5',
      },
    },
    engines: {
      'ai-engine': {
        name: 'AI \uc5d4\uc9c4',
        description:
          '\uc2e0\ud638 \uc0dd\uc131, \ud328\ud134 \uc778\uc2dd, \ubc0f \uc608\uce21 \ubaa8\ub378\ub9c1\uc744 \uc704\ud55c \uc2e0\uacbd\ub9dd',
      },
      'liquidity-engine': {
        name: '\uc720\ub3d9\uc131 \uc5d4\uc9c4',
        description:
          '\uae4a\uc740 \uc8fc\ubb38\ubd80 \uc9d1\uc57d\uacfc \ud06c\ub85c\uc2a4\uccb4\uc778 \uc720\ub3d9\uc131 \ub77c\uc6b0\ud305',
      },
      'execution-engine': {
        name: '\uc2e4\ud589 \uc5d4\uc9c4',
        description:
          'MEV \ubcf4\ud638\uc640 \ucd5c\uc801 \ub77c\uc6b0\ud305\uc744 \uac16\ucda4 100ms \ubbf8\ub9cc \uc8fc\ubb38 \uc2e4\ud589',
      },
      'risk-engine': {
        name: '\uc704\ud5d8 \uc5d4\uc9c4',
        description:
          '\uc2e4\uc2dc\uac04 \ud3ec\uc9c0\uc158 \uac10\uc2dc, \uccad\uc0b0 \ubcf4\ud638, \ubc0f \ud3ec\ud2b8\ud3f4\ub9ac\uc624 \ud5c8\uc9c0',
      },
    },
    roadmap: {
      q1: {
        title: '\ubca0\ud0c4 \ucd9c\uc2dc',
        items: [
          'AI Agents v1, 5\uac00\uc9c0 \uc804\ub7b5',
          '\ud37c\ud398\uce04\uc5bc \uac70\ub798 \uba54\uc778\ub137',
          'WebSocket \uc2e4\uc2dc\uac04 API',
          '\ud06c\ub85c\uc2a4\uccb4\uc778 \ube0c\ub9ac\uc9c0 \ud1b5\ud569',
        ],
      },
      q2: {
        title: '\uba54\uc778\ub137 \ud655\uc7a5',
        items: [
          '\uc608\uce21 \uc2dc\uc7a5 \ucd9c\uc2dc',
          'Python & TypeScript SDK',
          '\ubaa8\ubc14\uc77c \uac70\ub798 \uc571 \ubca0\ud0c4',
          '\uae30\uad00\uae09 API \uc561\uc138\uc2a4',
        ],
      },
      q3: {
        title: '\uc0dd\ud0dc\uacc4 \uc131\uc7a5',
        items: [
          '\uc804\ub7b5 \ubcfc\ud2b8 \ucd9c\uc2dc',
          '\ubcf5\uc0ac \uac70\ub798 \ud50c\ub7ab\ud3fc',
          'HyperEVM \uba40\ud2f0\uccb4\uc778',
          '\uc9c0\ubc29 \ud504\ub808\uc784\uc6cc\ud06c',
        ],
      },
      q4: {
        title: '\uc644\uc804\ud55c \ubd84\uc0b0\ud654',
        items: [
          'ZhiSu \ud1a0\ud070 \ucd9c\uc2dc',
          'DAO \uc9c0\ubc29',
          'Layer 2 \uc2a4\ucf00\uc77c\ub9c1',
          'AI \ubaa8\ub378 \ub9c8\ucf13',
        ],
      },
    },
    riskLevels: {
      high: '\ub192\uc74c',
      low: '\ub0ae\uc74c',
      veryHigh: '\ub9e4\uc6b0 \ub192\uc74c',
      medium: '\uc911\uac04',
    },
    footerLinks: {
      product: ['\uc2dc\uc7a5', 'AI \uc5d0\uc774\uc804\ud2b8', '\ubcfc\ud2b8', '\ub7ad\ud0b9', '\uc218\uc218\ub8cc'],
      developers: ['API \ucc38\uc870', 'SDK'],
      company: ['\ud68c\uc0ac \uc18c\uac1c', '\ucc44\uc6a9', '\ubcfc\ub3c4\uc790\ub8cc', '\ube0c\ub79c\ub4dc \uac00\uc774\ub4dc', '\ubb38\uc758'],
      legal: ['\uc774\uc6a9\uc57d\uad00', '\uac1c\uc778\uc815\ubcf4\ucc98\ub9ac\ubc29\uc2ec', '\ucfe0\ud0a4 \uc815\ucc45', 'AML \uc815\ucc45', '\uc704\ud5d8 \uacf5\uac1c', '\uc0ac\uc6a9\uc790 \ub3d9\uc758'],
    },
    timeAgo: '{{time}}\ucd08 \uc804',
  },
};